import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "actions";
import { Button } from "reactstrap";
import MessageModal from "components/MessageModal";

class index extends Component {
  state = {
    modal: false,
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  handleSendForm = formValues => {
    const { id: businessname, branch: location } = this.props;
    const { name, email, message } = formValues;
    if (name && email && message) {
      this.props.sendForm({ name, email, message, businessname, location });
      this.toggle();
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-lg-9 col-md-8 col-12">
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <img className="mb-2 img-fluid rounded" src={this.props.logo} alt="business page" />
            </div>
            <div className="col-md-6 col-lg-8">
              <h2 className="font-weight-bold">{this.props.title}</h2>
              <h5>{this.props.address}</h5>
              <h5>{this.props.phonenumber}</h5>
              <h5><a href={`mailto:${this.props.businessemail}`} target="_top">{this.props.businessemail}</a></h5>
              {/* <h5><a href={`mailto:${this.props.businessemail}`}>{this.props.businessemail}</a></h5> */}
              {this.props.website != "" ? <h5><a target="_blank" href={this.props.website}>{this.props.website}</a></h5>:null}
              <Link to={{ pathname: `${this.props.business_slug}/book-appointment` }}>
                <button type="button" className="jr-btn mt-3 btn-vibo2 text-white">
                  Book Now
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-12">
          <Button
            className="jr-btn jr-btn-lg bg-transparent text-vibo-text text-left border-0"
            href={`tel:${this.props.phonenumber}`}
          >
            <i className="zmdi zmdi-phone zmdi-hc-fw" />
            Call
          </Button>
          <Button
            role="button"
            className="jr-btn jr-btn-lg bg-transparent text-vibo-text text-left border-0"
            onClick={() => {
              this.toggle();
            }}
          >
            <i className="zmdi zmdi-comment-text-alt zmdi-hc-fw" /> Message
          </Button>
        </div>
        <MessageModal
          modal={this.state.modal}
          toggle={this.toggle}
          handleSendForm={this.handleSendForm}
          changeName={this.props.changeName}
          changeEmail={this.props.changeEmail}
          changeMessage={this.props.changeMessage}
          title={this.props.title}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ business, customerBooking }) => ({
  name: business.modalName,
  email: business.modalEmail,
  message: business.modalMessage,
  business: customerBooking.businessId,
});

const mapDispatchToProps = dispatch => ({
  changeName: payload => dispatch(actions.changeName(payload)),
  changeEmail: payload => dispatch(actions.changeEmail(payload)),
  changeMessage: payload => dispatch(actions.changeMessage(payload)),
  sendForm: payload => dispatch(actions.sendForm(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(index);



// WEBPACK FOOTER //
// ./components/ServiceHeader/index.js